export default __webpack_public_path__ + "static/latitude-reward-image-banner-mobile-2ba7f939035a04f730273719c3b498d6.png";